import { render, staticRenderFns } from "./InspectionLists.vue?vue&type=template&id=af2081ea&scoped=true&"
import script from "./InspectionLists.vue?vue&type=script&lang=js&"
export * from "./InspectionLists.vue?vue&type=script&lang=js&"
import style0 from "./InspectionLists.vue?vue&type=style&index=0&id=af2081ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2081ea",
  null
  
)

export default component.exports